import { getCore as get } from "../../utils/httpInterceptor";

const toQueryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });
  return query.toString();
};

const toIsoDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "" : date.toISOString();
};

const auditEventsService = {
  async search(filters = {}, page = 0, size = 50) {
    const qs = toQueryString({
      ...filters,
      from: toIsoDateTime(filters.from),
      to: toIsoDateTime(filters.to),
      page,
      size,
    });
    return get(`/api/audit/events?${qs}`);
  },

  async searchSalesActions(filters = {}, page = 0, size = 50) {
    const qs = toQueryString({
      ...filters,
      from: toIsoDateTime(filters.from),
      to: toIsoDateTime(filters.to),
      page,
      size,
    });
    return get(`/api/audit/events/sales-actions?${qs}`);
  },
};

export default auditEventsService;
